exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn[data-v-7879a200]{margin:10px}.pointer[data-v-7879a200]{cursor:pointer;position:relative}.used-bg[data-v-7879a200]{position:absolute;top:0;left:0;background-color:hsla(0,0%,100%,.4);color:#fff;z-index:1}.used-text[data-v-7879a200]{font-size:18px;color:#fff;background-color:#e34f4f;padding:3px 8px;-webkit-transform:rotate(-5deg);transform:rotate(-5deg)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7879a200","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/my_vouchers.vue
// module id = N/O8
// module chunks = 0